import CityPageTemplate from "../city-template/CityPageTemplate";
import { montroseConfig } from "./data";

export default function MontrosePage() {
  return <CityPageTemplate config={montroseConfig} />;
}